export { default, type ApplicationsSectionProps } from './ApplicationsSection';
